import classNames from 'classnames';
import React from 'react';

import styles from './styles.module.less';

export const TOP_LEFT = 'topLeft';
export const TOP_RIGHT = 'topRight';
export const OUTSIDE_LEFT_CENTER = 'outsideLeftCenter';

export default class ActionDot extends React.PureComponent {
  render() {
    const { position = TOP_LEFT } = this.props;

    const containerClassName = classNames(styles.container, styles[position]);

    return (
      <div className={containerClassName}>
        <div className={styles.ring} />
        <div className={styles.dot} />
      </div>
    );
  }
}
